export const validateUri = uri => {
  if (
    /* eslint-disable-next-line */
    !/^(?:http(s)?:\/\/){1,1}[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/.test(
      uri
    )
  ) {
    return 'Wrong URL format';
  }
};
